import { render } from "./ListOrganismeDemandeur.vue?vue&type=template&id=c81287c0&scoped=true"
import script from "./ListOrganismeDemandeur.vue?vue&type=script&lang=js"
export * from "./ListOrganismeDemandeur.vue?vue&type=script&lang=js"

import "./ListOrganismeDemandeur.vue?vue&type=style&index=0&id=c81287c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81287c0"]])

export default __exports__